import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { useReportCarouselRenderState } from 'src/components/carousels/carousel-render-state';
import { defaultFilters } from '../carousels.utils';

export function TopSellersCarousel(props) {
  const { loading, products } = useDispensaryProducts({
    filters: {
      ...defaultFilters,
      sortBy: `popular`,
      useCache: true,
    },
    perPage: 25,
  });

  const title = props?.title ?? `Top Sellers`;
  useReportCarouselRenderState({ loading, hasContent: Boolean(products?.length) });

  if (!products?.length && !loading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={title}
      analyticsSection='Top Sellers'
      isSmallTitle={props?.isSmallTitle}
      alwaysUseSmallCards={props?.alwaysUseSmallCards}
    />
  );
}
